import PageHeader from "@/components/page-header"
import { t } from "i18next"
import SaveToast from "@/components/SaveToast"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { toast } from "react-toastify"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import UnitEditForm from "@/features/risks/entities/unit/ui/UnitEditForm"
import UnitDeleteModal from "./modals/UnitDeleteModal"
import Button from "@/components/button"
import { faSitemap, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function RisksUnitHome() {
  const dispatch = useAppDispatch()

  const isEdited = useAppSelector(unitStore.selectors.isEdited)
  const navigate = useNavigate()

  const status = useAppSelector(unitStore.selectors.status)
  const units = useAppSelector(unitStore.selectors.list)
  const unit = useAppSelector(unitStore.selectors.draft)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)

  const handleCancel = () => {
    dispatch(unitStore.actions.cancel())
  }

  const handleClose = () => {
    dispatch(unitStore.actions.setActive(null))
    navigate("/risks/units")
  }

  const handleSave = async () => {
    if (!isEdited || !unit) return

    // Validate that name is not empty
    if (!unit.name || unit.name.trim() === "") {
      toast(t("Le nom de l'unité de travail est obligatoire"), { type: "error" })
      return
    }

    // dispatch(unitStore.thunks.setJobsForUnit({ unitId: draft.id, JobIds }))

    try {
      const exists = units.some((u) => u.id === unit.id)
      if (exists) {
        await dispatch(unitStore.thunks.updateEntity()).unwrap()
      } else {
        await dispatch(unitStore.thunks.createEntity(unit)).unwrap()
      }
    } catch (err) {
      console.error("❌ Save failed", err)
    }
  }

  return (
    <div>
      {isDeleteModalOpen && <UnitDeleteModal onClose={() => setIsDeleteModalOpen(false)} />}

      <PageHeader
        title={
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faSitemap} className="grey-t" />
            {t("units_edit")}
          </div>
        }>
        <Button
          className="secondary"
          isWithBorder
          onClick={() => navigate("/risks/risks-add", { state: { backTo: "/risks/units" } })}
          icon={faTriangleExclamation}>
          {t("risks_add")}
        </Button>
      </PageHeader>

      <UnitEditForm isWizard={false} />

      <SaveToast
        status={status}
        isSaveActive={isEdited}
        onCancel={handleCancel}
        onClose={handleClose}
        onDelete={() => setIsDeleteModalOpen(true)}
        onSave={handleSave}
      />
    </div>
  )
}
